import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Grid,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { CustomButton } from '../layout/styledcomponents/CustomButton';

export default function InitBeforeUnLoad(showExitPrompt: boolean) {
    window.onbeforeunload = (event) => {
        if (showExitPrompt) {
            const e = event || window.event;
            e.preventDefault();

            if (e) {
                e.returnValue = '';
            }

            return '';
        }
    };
}

// Hook
export function useExitPrompt(bool: any) {
    const [showExitPrompt, setShowExitPrompt] = useState(bool);
    window.onload = function () {
        InitBeforeUnLoad(showExitPrompt);
    };

    useEffect(() => {
        InitBeforeUnLoad(showExitPrompt);
    }, [showExitPrompt]);

    return [showExitPrompt, setShowExitPrompt];
}

export const ExitDialog = ({ onClose, onOk, visible = false }: any) => {
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const theme = useTheme();

    return (
        <Dialog open={visible} onClose={onClose}>
            <Grid
                sx={{
                    width: '100%',
                    height: '100%',
                }}
            >
                <Grid
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        textAlign: 'left',
                        height: '50px',
                        width: '600px',
                        paddingLeft: '18px',
                        alignContent: 'center',
                        alignItems: 'center',
                        borderBottom: `${theme.palette.faded.main} solid 1px`,
                    }}
                >
                    <Grid
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                        }}
                    >
                        <Typography variant='h6'>
                            Are you sure you want to leave?
                        </Typography>
                    </Grid>
                </Grid>
                <DialogContent
                    dividers
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        height: 'auto',
                    }}
                >
                    <DialogContentText>
                        <Grid
                            sx={{
                                display: 'flex',
                                alignContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            TEXT HERE
                        </Grid>
                    </DialogContentText>
                </DialogContent>{' '}
                <DialogActions>
                    <Grid>
                        {' '}
                        <CustomButton
                            variant='contained'
                            color='neutral'
                            onClick={onClose}
                        >
                            Cancel
                        </CustomButton>
                    </Grid>
                    <Grid>
                        {' '}
                        <CustomButton
                            variant='contained'
                            color='primary'
                            onClick={onOk}
                            sx={{
                                top: isMobile || isIpad ? '10%' : '50%',
                            }}
                        >
                            Move
                        </CustomButton>
                    </Grid>
                </DialogActions>
            </Grid>
        </Dialog>
    );
};
